import API from "./API";

export default class LogAPI extends API {
  constructor(parameters = {}) {
    super("/Log", parameters);
  }

  getLast() {
    return this.submit("get", `${this.endpoint}/GetLast`);
  }

  getAll() {
    return this.submit("get", `${this.endpoint}/GetAll`, {responseType: 'arraybuffer'}, 'application/zip');
  }
  getClosedPeriodLogs() {
    return this.submit("get", `${this.endpoint}/GetClosedPeriodLogs`, { responseType: 'blob' });
  }
}
